import { render, staticRenderFns } from "./tab-6-record-news.vue?vue&type=template&id=7fb9ee8c&scoped=true&lang=pug&"
import script from "./tab-6-record-news.vue?vue&type=script&lang=js&"
export * from "./tab-6-record-news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb9ee8c",
  null
  
)

export default component.exports